import React from 'react';
import {
  Home,
  Dog,
  CookingPot,
  Leaf,
  Wrench,
  Package,
  Shirt,
  ShoppingCart,
  Baby,
  BookOpen,
  Laptop,
  Sparkles,
  ClipboardList,
} from 'lucide-react';

const ICON_MAP = {
  cleaning: Home,
  'dog-walking': Dog,
  cooking: CookingPot,
  gardening: Leaf,
  handyman: Wrench,
  moving: Package,
  laundry: Shirt,
  errands: ShoppingCart,
  childcare: Baby,
  tutoring: BookOpen,
  tech: Laptop,
  other: Sparkles,
};

const ServiceIcon = ({ serviceId, size = 20, className = '', ...props }) => {
  const IconComponent = ICON_MAP[serviceId] || ClipboardList;
  return <IconComponent size={size} className={className} {...props} />;
};

export { ICON_MAP };
export default ServiceIcon;
